module.exports = __webpack_public_path__ + "img/ocbc-illustration-1.30440cea.svg";